import * as styles from "./IntroHeroWithImageRight.module.scss";

import React, { useEffect } from "react";
import { useState } from "react";
import FurryCurvedBorder from "../../../components/borders/FurryCurvedBorder";
import ProcessedImage from "../../../components/common/ProcessedImage/ProcessedImage";
import { Colours } from "../../../utils/colours";
export interface IntroHeroWithImageRightProps {
	title: string;
	body: string;
	imgSrc: string;
	imgAlt: string;
	borderColour?: string;
}

export const IntroHeroWithImageRight: React.FC<
	IntroHeroWithImageRightProps
> = ({ title, body, imgSrc, imgAlt, borderColour = Colours.WHITE }) => {
	const [imageHeight, setImageHeight] = useState(0);

	useEffect(() => {
		const getImageHeight = () => {
			const image = document.getElementById("intro-hero-image");
			if (image) {
				setImageHeight(image.clientHeight);
			}
		};
		getImageHeight();

		window.addEventListener("resize", getImageHeight);
		return () => {
			window.removeEventListener("resize", getImageHeight);
		};
	}, []);

	useEffect(() => {
		const borderContainer = document.getElementById(
			"intro-hero-image-border-container",
		);
		if (borderContainer) {
			borderContainer.style.height = `${imageHeight}px`;
		}
	}, [imageHeight]);

	return (
		<>
			<div className={styles.herowithimagecontainerdesktop}>
				<div className={styles.topsectionouter}>
					<div className={styles.topsectioninner}>
						<div className={styles.textcontainer}>
							<div className={styles.title}>
								<h1>{title}</h1>
							</div>
							{!!body && (
								<div className={styles.subtitle}>
									<div
										// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
										dangerouslySetInnerHTML={{
											__html: body,
										}}
									/>
								</div>
							)}
						</div>
						<div className={styles.imagecontainer}>
							<div className={styles.imagewrapper}>
								<ProcessedImage
									src={imgSrc}
									alt={imgAlt}
									dimensions="800x600"
									loading="eager"
								/>
							</div>
						</div>
					</div>
				</div>
				<div className={styles.bordersection}>
					<FurryCurvedBorder
						className={styles.border}
						fill={borderColour}
						rotation={0}
					/>
				</div>
			</div>
			<div className={styles.herowithimagecontainermobile}>
				<div className={styles.topsectionouter}>
					<div className={styles.textcontainer}>
						<div className={styles.title}>
							<h1>{title}</h1>
						</div>
						{!!body && (
							<div className={styles.subtitle}>
								{/* biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source */}
								<div dangerouslySetInnerHTML={{ __html: body }} />
							</div>
						)}
					</div>
				</div>
				<div
					id="intro-hero-image-border-container"
					className={styles.bordersection}
				>
					<FurryCurvedBorder
						className={styles.border}
						fill={borderColour}
						rotation={0}
					/>
					<div className={styles.imagecontainer}>
						<div className={styles.imagewrapper}>
							<ProcessedImage
								id="intro-hero-image"
								src={imgSrc}
								alt={imgAlt}
								dimensions="800x600"
								loading="eager"
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default IntroHeroWithImageRight;
